import SectionHeader from "@/components/SectionHeader";
import { Reveal } from "@/components/Reveal";

export const Skills = ({ skills = [] }) => {
  return (
    <section data-testid="skills-section" className="py-24 lg:py-32 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <SectionHeader
              index="04"
              eyebrow="Toolkit"
              title="Skills & tools"
              description="The craft and the tooling I lean on to move from research to a shipped, polished product."
            />
          </div>

          <div className="lg:col-span-8 space-y-10">
            {skills.map((group, gi) => (
              <Reveal key={group.group} delay={gi * 0.06}>
                <div data-testid={`skill-group-${gi}`} className="border-t border-white/10 pt-6">
                  <p className="text-xs tracking-[0.2em] uppercase text-ash mb-4">{group.group}</p>
                  <div className="flex flex-wrap gap-2.5">
                    {group.items.map((item) => (
                      <span
                        key={item}
                        className="rounded-full border border-white/15 px-4 py-1.5 text-sm text-cream/85 hover:border-white/40 hover:text-cream transition-colors"
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
